
import { useState,useEffect } from "react";
import "./App.css";
export default function BottomTabs({section}) {
  const [selected,setSelected] = useState(0);
  
  useEffect(() => {
    var h = window.location.hash;
    if(h && h == '#WHEEL'){
      setSelected(2);
    }
  },[]);

  return (
    <>
      <div className="bottomTabsContainer" style={{
        display:(section === 'EMORYANADVENTURE') ? 'none' : ''
      }}>
      <div className="bottomTabsOuter row">
        <div className="col-3 " onClick={() => {
            global.changeSection('HOME');
            setSelected(0);
        }} style={{
          color:(selected === 0) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-house"></i>
            <br/>
            HOME
        </div>
        <div className="col-3"  onClick={() => {
            global.changeSection('TEAMS');
            setSelected(1);
        }} style={{
          color:(selected === 1) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-people-group"></i>
            <br/>
            Teams
        </div>
        <div className="col-3"  onClick={() => {
            global.changeSection('GAMES');
            setSelected(2);
        }} style={{
          color:(selected === 2) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-gamepad"></i><br/>
            Games
        </div>
        <div className="col-3"   onClick={() => {
            global.changeSection('PROFILE');
            setSelected(3);
        }} style={{
          color:(selected === 3) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-regular fa-circle-user"></i><br/>
            Profile
        </div>

      </div>

      </div>
    </>
  );
}
